/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from 'react-modal';

interface Props {
  isOpen: boolean;
  close: () => void;
  title: React.ReactElement<any, any> | string;
  warning?: React.ReactElement<any, any> | string;
  buttonTitle?: React.ReactElement<any, any> | string;
  onHandle: () => void;
  isSubmitButtonDisabled?: boolean;
}

export const ItemActionModal = ({
  isOpen,
  close,
  title,
  onHandle,
  isSubmitButtonDisabled,
  buttonTitle = 'delete',
  warning = undefined,
}: Props) => {
  const { t } = useTranslation();

  const renderTitle = useMemo(() => (typeof title === 'string' ? t(title) : title), [title]);

  const renderWarning = useMemo(() => {
    if (warning) {
      return (
        <div className="mb-[24px] text-center text-[16px] text-[#656D7B] lg:text-[20px]">
          {typeof warning === 'string' ? t(warning) : warning}
        </div>
      );
    }
  }, [warning]);

  const renderButtonTitle = useMemo(
    () => (typeof buttonTitle === 'string' ? t(buttonTitle) : buttonTitle),
    [buttonTitle],
  );

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={close}
      className="bottom-auto mx-auto w-[85%] translate-y-[35vh] rounded-xl bg-white p-[30px] lg:w-[520px]"
      overlayClassName="z-10 w-full fixed top-0 left-0 rigth-0 bottom-0 bg-[#0d0d0ccc]"
      closeTimeoutMS={300}
    >
      <div className="mb-[15px] text-center text-[20px] font-bold lg:text-[32px]">{renderTitle}</div>

      {renderWarning}

      <div className="flex justify-center gap-[12px]">
        <button
          className={`btn btn-delete more w-1/2 ${typeof buttonTitle === 'string' && buttonTitle?.includes('delete' || 'denied') ? 'bg-[#FA6238] text-black' : 'bg-[#9bdffc]'} `}
          onClick={() => onHandle()}
          disabled={isSubmitButtonDisabled}
        >
          {renderButtonTitle}
        </button>

        <button className="btn more w-1/2" onClick={() => close()} disabled={isSubmitButtonDisabled}>
          {t('cancel')}
        </button>
      </div>
    </Modal>
  );
};
